export const typography = {
  fontFamily: 'Open Sans, sans-serif',
  fontStyle: 'normal',
  h1: {
    fontSize: '1.8rem',
    fontWeight: 600,
  },
  h2: {
    fontSize: '1.3rem',
    fontWeight: 400,
  },
  h3: {
    fontSize: '1.1rem',
  },
  h4: {
    fontSize: '1rem',
    fontWeight: 700,
  },
  h5: {
    fontSize: '1.5rem',
    fontWeight: 700,
  },
  h6: {
    fontSize: '1.5rem',
    fontWeight:600,
  },
  body1: {
    fontSize: '1.3rem',
    fontWeight: 600,
  },
  body2: {
    fontSize: '0.8rem',
    fontWeight: 400,
  },
  subtitle1: {
    fontSize: '1rem',
    fontWeight: 400,
  },
  subtitle2: {
    fontSize: '1rem',
    fontWeight: 600,
  },
};
